<template>
  <div>
     <Treeselect  v-model="server_obj" valueConsistsOf='LEAF_PRIORITY' @input="eventInput" valueFormat="object"
                 :multiple="true" :options="options"  :load-options="loadOptions" :searchable="false" :disableBranchNodes="true" placeholder="选择主机">
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                 <Icon v-if="node.raw.ip" type="ios-desktop" />
                 <Icon  v-else-if="'children' in  node.raw" type="ios-folder-open-outline" />
                 <Icon  v-else type="ios-desktop-outline" />{{ node.label }} {{ node.raw.ip }}
                </label>
            </Treeselect>
  </div>
</template>

<script>
import { Treeselect, LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
import { getServerOrg } from '@/api/opscenter'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'ServerTree',
  props: ['hosts'],
  components: {
    Treeselect
  },
  data () {
    return {
      options: [],
      server_obj: null
    }
  },
  watch: {
    hosts () {
      this.getServerOrg(0)
    }
  },
  mounted: function () {
    // this.getServerOrg(0)
  },
  methods: {
    eventInput (value, instanceId) {
      console.log(value)
    },
    getServerOrg (id) {
      let params = {
        parentid: id,
        hosts: this.hosts.join(',')
      }
      getServerOrg(params).then(res => {
        if (id === 0) {
          this.options = res.data.result
        } else {
          return res.data.result
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取服务器组列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取服务器组列表失败！服务器无响应'
          })
        }
      })
    },
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1,
          hosts: this.hosts.join(',')
        }
        getServerOrg(params).then(res => {
          parentNode.children = res.data.result
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取服务器组列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取服务器组列表失败！服务器无响应'
            })
          }
        })
      }
    }
  }
}
</script>

<style>
</style>
